import { jsx } from 'react/jsx-runtime';
import { EGDSInput } from '../input/index.esm.js';
import '../faux-input/index.esm.js';
import 'react';
import '../password-input/index.esm.js';
import '../informative-input/index.esm.js';
import '../textarea/index.esm.js';
import '../chat-textarea/index.esm.js';
import '../fake-input/index.esm.js';
import '../card-number-input/index.esm.js';
import '../select/index.esm.js';
import '../swapper-input/index.esm.js';
const EGDSNumberInput = props => jsx(EGDSInput, {
  ...props,
  type: "number"
});
export { EGDSNumberInput };